import { cva } from "cva";

export const navbarPortalStyles = cva({
  base: "absolute z-100 top-full left-0 pt-20 pb-10 rounded-xs",
  variants: {
    isMenuOpen: {
      true: "pointer-events-auto",
      false: "pointer-events-none",
    },
  },
});

export const navbarPortalContentStyles = cva({
  base: "grid-contain place-items-start rounded-default shadow-md will-change-transform",
});
